module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMQFhb/TwlmGDVg1IBRA4aLAQClkDwQkiCLlAAAAABJRU5ErkJggg=="